import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import Login from "../Login/Login";
import {TasksContainer} from "../Tasks/tasks/TasksContainer";
import {Alert, ReduxProtectedRoute} from "@leap4/frontend";
import {Role} from "@leap4/auth";
import {urlsService} from "./urlsService";
import {AddTask} from "../Tasks/task/create/AddTask";
import {EditTask} from "../Tasks/task/edit/EditTask";

export const requiredAuthRoles: Role[] = [Role.ADMIN];
const backEndServiceName = process.env.REACT_APP_SERVICE_NAME || "";

const Routes = () => {
    return (
        <section className="container">
            {/* <Alert /> */}
            <Alert />
            <Switch>
                <Route exact path={urlsService.login()} component={Login}/>
                <Redirect exact from="/home" to={urlsService.tasks()} />
                <ReduxProtectedRoute exact path={urlsService.app()} backendServiceName={backEndServiceName} component={TasksContainer}
                                     requiredRoles={requiredAuthRoles}/>
                <ReduxProtectedRoute exact path={urlsService.tasks()} backendServiceName={backEndServiceName}
                                     component={TasksContainer} requiredRoles={requiredAuthRoles}/>
                <ReduxProtectedRoute exact path={urlsService.createTask()} backendServiceName={backEndServiceName}
                                     component={AddTask} requiredRoles={requiredAuthRoles}/>
                <ReduxProtectedRoute exact path={urlsService.editTask()} backendServiceName={backEndServiceName}
                                     component={EditTask} requiredRoles={requiredAuthRoles}/>
            </Switch>
        </section>
    );
};

export default Routes;